import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';

import { saveItemToCart } from '../../../../actions/shop';
import { getTitle } from '../../../../helpers/admin/productHelper';

import AddToCartDialog from '../../../Tienda/Product/AddToCartDialog';

//MUI
import {
    Alert, Button, Card, CardActions, CardContent, CardMedia,
    Grid, Typography, Stack
} from '@mui/material';
import { styled } from "@mui/material/styles";

import { PROMO_INIT } from '../../../../constants/shop/promotion/promotion_const';

const ButtonGreen = styled(Button)(({ theme }) => ({
    color: '#fff',
    backgroundColor: '#56C596',
    fontWeight: '600',
    paddingTop: '8px',
    paddingBottom: '8px',
    '&:hover': {
        backgroundColor: '#358f69',
        color: '#fff'
    }
}));

const BuyAgain = () => {
    const dispatch = useDispatch();

    // productos de tienda y datos de navegación
    const { products } = useSelector(state => state.shop);
    const { buyAgainProducts } = useSelector(state => state.user_account);

    const [item, setItem] = useState([]);
    const [variant, setVariant] = useState({
        _id: '', item_promotion: PROMO_INIT
    });
    const { _id, item_promotion } = variant;
    
    useEffect(() => {
        // cliente tiene compras
        if (buyAgainProducts.length > 0) {
            // productos en tienda que cliente ya ha comprado
            const filtered = products.filter(
                e => e.prod_variants.filter(
                    ({ _id }) => buyAgainProducts.map(
                        ({ prod_var_id }) => prod_var_id
                    ).includes(_id)
                ).length > 0
            ).map(
                ({ prod_variants }) => prod_variants.map(
                    ({ _id, item_promotion }) => ({ _id, item_promotion })
                )
            );

            if (filtered.length > 0) {
                let MyProducts = [];
                // incluir promoción de producto (en caso de)
                // para mostrar el precio correcto
                for (const item of buyAgainProducts) {
                    const { prod_var_id } = item;
                    for (const product of filtered) {
                        for (const variant of product) {
                            const { _id, item_promotion } = variant;
                            if (_id === prod_var_id)
                                MyProducts = [...MyProducts, {
                                    ...item, item_promotion
                                }];
                        };
                    };
                };
                setItem(MyProducts);
            }
        }
    }, [buyAgainProducts, products]);

    // agregar producto a carrito
    const addToCart = model => () => {
        const { prod_var_id, item_promotion } = model;
        setVariant(e => ({ ...e, _id: prod_var_id, item_promotion }));
        dispatch(saveItemToCart({
            ...model, quantity: 1
        }, { flag: true, message: [] }, () => {}));
        // Tag Manager
        window.dataLayer.push({
            event: 'add-to-cart'
        });
    };
    
    return (
        <>
            {
                item.length > 0 ?
                    <Grid container spacing={4}>
                        {
                            item.map(({
                                prod_id, prod_var_id, title, variant_title, price, img,
                                item_promotion: { promo, price: promo_price }
                            }) => (
                                <Grid item xl={3} lg={3} md={4} sm={6} xs={12}
                                    key={ prod_var_id } sx={{ display: 'flex' }}>
                                    <Card sx={{ width: '100%', position: 'relative', boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 160, height: 160, objectFit: 'cover', mx: 'auto', mt: 3 }}
                                            image={ img.id }
                                            title={ getTitle(title, variant_title) }
                                        />
                                        <CardContent sx={{ mb: 6 }}>
                                            <Typography variant='body2' gutterBottom>
                                                { getTitle(title, variant_title) }
                                            </Typography>
                                            {
                                                ['DescuentoProducto', 'DescuentoMarca'].includes(promo) ?
                                                    <Stack
                                                        direction="row"
                                                        justifyContent="flex-start"
                                                        alignItems="baseline"
                                                        spacing={1}>
                                                        <Typography variant="body1"
                                                            sx={{ fontWeight: '600', color: '#000', textDecoration: 'line-through' }}>
                                                            ${price}
                                                        </Typography>
                                                        <Typography variant="body1"
                                                            sx={{ fontWeight: '600', color: '#F90606' }}>
                                                            ${promo_price}
                                                        </Typography>
                                                    </Stack>
                                                :
                                                    <Typography variant='body1' sx={{ fontWeight: '600' }}>
                                                        ${price}
                                                    </Typography>
                                            }
                                        </CardContent>
                                        <CardActions sx={{ position: 'absolute', bottom: 0, width: '100%', px: 2 }}>
                                            <ButtonGreen size="small" variant='contained'
                                                sx={{ width: '100%', textTransform: 'none' }}
                                                onClick={
                                                    addToCart({ prod_id, prod_var_id, item_promotion })
                                                }>
                                                Agregar al carrito
                                            </ButtonGreen>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))
                        }
                    </Grid>
                :
                    <Alert severity="warning">
                        Aún no cuentas con ninguna compra - <Link to='/tienda'>Comenzar a comprar</Link>
                    </Alert>
            }
            <AddToCartDialog
                variant={ { _id, item_promotion } }
            />
        </>
    );
};

export default BuyAgain;